
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSignFireEquipment as ObiSignFireEquipmentElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-sign-fire-equipment.js';
 
 
 

 
 export const ObiSignFireEquipment = createComponent({
   react: React,
   tagName: 'obi-sign-fire-equipment',
   elementClass: ObiSignFireEquipmentElement,
   events: {
     
   }
  });
 
 